import GameList from '../components/GameList/GameList.js';
import Page from '../components/Page/Page.js';

function HomePage()
{
    return(
        <Page mainSection={<GameList />} />
    );
}

export default HomePage;